/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';
import type { ButtonProps } from '@coursera/cds-core';

import withSingleTracked from 'bundles/common/components/withSingleTracked';
import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/enroll-course';

const TrackedButton = withSingleTracked({ type: 'BUTTON' })<ButtonProps>(Button);

type CourseraPlusPrePurchaseUpsellModalProps = {
  onDeclinePrePurchaseUpsell: (shouldGoToCheckoutOnClose: boolean) => void;
  onContinue: () => void;
};

const styles = {
  bodyContainer: css`
    margin-bottom: var(--cds-spacing-400);
  `,
};

// Note: This component was almost entirely AI generated. It does not necessarily reflect what is specified in the requirements.
export const CourseraPlusPrePurchaseUpsellModal = ({
  onDeclinePrePurchaseUpsell,
  onContinue,
}: CourseraPlusPrePurchaseUpsellModalProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDeclineLoading, setIsDeclineLoading] = useState(false);

  const { HeadingGroup, Content, Actions } = Dialog;

  const handleContinue = () => {
    setIsLoading(true);
    onContinue();
  };

  const handleDecline = () => {
    setIsDeclineLoading(true);
    onDeclinePrePurchaseUpsell(true);
  };

  return (
    <Dialog open onClose={() => onDeclinePrePurchaseUpsell(false)}>
      <TrackedDiv
        withVisibilityTracking={true}
        trackingName="pre_purchase_upsell_modal"
        trackingData={{ modalType: 'pre_purchase_upsell' }}
      >
        <HeadingGroup>{_t('Get unlimited access with Coursera Plus')}</HeadingGroup>
        <Content>
          <div css={styles.bodyContainer}>
            <Typography2 variant="bodyPrimary" component="p">
              {_t(
                'Save money and learn at your own pace with unlimited access to 10,000+ courses, projects, Specializations, and Professional Certificates.'
              )}
            </Typography2>
          </div>
        </Content>
        <Actions>
          <TrackedButton
            variant="primary"
            onClick={handleContinue}
            loading={isLoading}
            disabled={isLoading}
            trackingName="pre_purchase_upsell_continue_button"
            data-testid="pre_purchase_upsell_continue_button"
          >
            {_t('Continue with Coursera Plus')}
          </TrackedButton>
          <TrackedButton
            variant="ghost"
            onClick={handleDecline}
            loading={isDeclineLoading}
            disabled={isLoading || isDeclineLoading}
            trackingName="pre_purchase_upsell_close_button"
            data-testid="pre_purchase_upsell_close_button"
          >
            {_t('No thanks')}
          </TrackedButton>
        </Actions>
      </TrackedDiv>
    </Dialog>
  );
};

export default CourseraPlusPrePurchaseUpsellModal;
